<script setup lang="ts">
import { computed } from 'vue'

import { Button } from '@collector/shared-ui'
import { IncidentId } from '@collector/sportsapi-client-legacy'
import {
  useBlockades,
  useEventIncidentsQueue,
} from '@desktop/views/Relation/Sports/composables'
import { injectPocketIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

interface Props {
  incidentId: IncidentId
  sendIncident?: boolean
  variant?: 'flat'
}

const props = withDefaults(defineProps<Props>(), {
  sendIncident: true,
})

// composables
const eventIncidentsQueue = useEventIncidentsQueue()

// inject
const { blockedPocketIncidentsMap } = injectPocketIncidentsConfig()

// composables
const { isIncidentBlocked } = useBlockades()

// computed
const disabled = computed(
  () =>
    blockedPocketIncidentsMap &&
    isIncidentBlocked(props.incidentId, blockedPocketIncidentsMap),
)

// methods
function handleClick(): void {
  if (props.sendIncident === false) return

  eventIncidentsQueue.addIncident(
    {
      incident_id: props.incidentId,
    },
    { shouldResetPossession: true },
  )
}
</script>

<template>
  <Button
    class="hover:enabled:bg-neutral-3 hover:enabled:border-neutral-3 enabled:active:bg-neutral-1 px-1.5 font-bold"
    :class="{
      'bg-neutral-light-7 border-neutral-light-0': variant !== 'flat',
    }"
    fontSize="text-2xs"
    size="sm"
    width="full"
    :disabled
    @click="handleClick"
  >
    <slot />
  </Button>
</template>
